document.addEventListener(
    "DOMContentLoaded", () => {
        const iFrameButtons = document.querySelectorAll('.control-iframe .btn');
        iFrameButtons.forEach(el => el.addEventListener('click', event => {
            event.preventDefault();

            var frameId = el.dataset.frameId;

            var iFrameWrapper = document.getElementById(frameId);
            if (iFrameWrapper.classList.contains('opened')) {
                iFrameWrapper.classList.remove('opened');

            } else {
                iFrameWrapper.classList.add('opened');
            }
        }));
    }

);